import { Component, Input } from '@angular/core';
import {ObjectsService} from "@app/_services";

@Component({
  selector: 'cards-item-columns',
  templateUrl: './cards-item-columns.component.html',
  styleUrls: ['./cards-item-columns.component.scss']
})
export class CardsItemColumnsComponent {
  @Input() card:any;
  show:boolean;

  constructor(private objectsService: ObjectsService) {
  }

  get html1() {
    return this.objectsService.getValue(this.card, 'column-1')
  }
  get html2() {
    return this.objectsService.getValue(this.card, 'column-2')
  }
}
